interface ISwitchArrowsProps {
  height?: string;
  width?: string;
}

export const SwitchArrows = ({ height = "16", width = "16" }: ISwitchArrowsProps) => (
  <svg
    height={height}
    width={width}
    fill="none"
    viewBox="0 0 17 16"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.83331 14V2L2.83331 6M10.1666 1.73367V13.7337L14.1666 9.73367"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
  </svg>
);
